import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import documentUtil from 'src/utils/documentUtil';
import { all_statuses, static_statuses, CONSTANTS } from 'src/constants';

export const useDocStatusDropdownStore = defineStore('doc_status_dropdown', {
  state: () => ({
    status_list: [] as any,
    status_list_loading: false,
    diff_key_value_status: {
      exported: 'finished',
    } as dynamicObj,
  }),
  actions: {
    getStatusesList(style: string) {
      try {
        this.status_list_loading = true;
        this.status_list = [];

        let statuslist = [] as string[];
        if (style == CONSTANTS.all) {
          statuslist = all_statuses;
        } else if (style == CONSTANTS.static) {
          statuslist = static_statuses;
        }

        statuslist.forEach((item, index) => {
          let key = item;
          if (this.diff_key_value_status.hasOwnProperty(item)) {
            key = this.diff_key_value_status[item];
          }
          this.status_list.push(
            Object.assign(
              {},
              {
                value: key,
                label: documentUtil.methods.getLabelTranslation(item),
              },
            ),
          );
        });
      } catch (err) {
        logError(err);
      } finally {
        this.status_list_loading = false;
      }
    },
  },
});
